import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, MainHeading, SpanStyled, TitleHeading } from '../../../ui/Elements'
import { ArrowBtnBrown, ComMap, MBS, ServicesBg, ServicesImg, ServicesImgAr, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr, Vision, VisionAr, VisionBg, VisionBgAr } from '../../../ui/AllImages'

import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
import { ServicesList, VisionMissionList } from '../../projectData/Data'
import Stats from '../stats/Stats'
import CeoMessage from '../ceo/CeoMessage'
import { Animate } from 'react-simple-animate'
const Services = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
          const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
            const observer = new IntersectionObserver(
              ([entry]) => {
                // When visible, set to true
                if (entry.isIntersecting) {
                  setIsVisible(true);
                  observer.disconnect(); // run animation once
                }
              },
              {
                threshold: 0.2, // 20% of section visible triggers the animation
              }
            );
        
            if (sectionRef.current) {
              observer.observe(sectionRef.current);
            }
        
            return () => observer.disconnect();
          }, []);
            const start = { opacity: 0, transform: 'translateY(-40px)' };
            const end = { opacity: 1, transform: 'translateY(0)' };
            const start2 = { opacity: 0, transform: 'translateY(100px)' };
            const end2 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <Box  id='srvices'>
            <ServicesWapper className='container-fluid secSerrvices common-space' ref={sectionRef}>
                <Container>
                    <Row className='services-row'>
                        
                        <Col md={12} className='services-col-wrap services-cntnt-col-wrap'>
                            <Row className='servicesRow'>
                                <Col lg={6} md={12} className='services-col services-col-img'>
                                <Animate
                                                                        play={isVisible}
                                                                        duration={1}
                                                                        delay={.5}
                                                                        start={start}
                                                                        end={end}
                                                                    >
                                    {i18n.language === "ar" ? <img src={ServicesImgAr} alt="building" /> : <img src={ServicesImg} alt="building" /> }
                                    </Animate>
                                </Col>
                                <Col lg={6} md={12} className='services-col services-col-ctnt'>
                                <Animate
                                        play={isVisible}
                                        duration={1}
                                        delay={.5}
                                        start={start}
                                        end={end}
                                    >
                                    <MainHeading className='main-heading main-heading-services mb-5' color="var(--white)">
                                        {t('OurServices')}
                                    </MainHeading>
                                    </Animate>
                                    {ServicesList.map((list, key) => (
                                        <Animate
                                        play={isVisible}
                                        duration={1}
                                        delay={1}
                                        start={start}
                                        end={end}
                                    >
                                        <Box className='servicesPointsContent mb-4' key={key}>
                                            <Box className='servicesIconImg'>
                                                {list.img}
                                            </Box>
                                            <Box className='servicesPointsContentInner'>
                                                <TitleHeading className='main-heading main-heading-serv mb-2'>
                                                    {t(list.title)}
                                                </TitleHeading>
                                                <SpanStyled className='services-txt mb-4' color='var(--bg2)' size="22px">
                                                    {t(list.txt)}
                                                </SpanStyled>
                                            </Box>
                                        </Box>
                                        </Animate>
                                    ))}
                                </Col>
                                
                            </Row>
                        </Col>
                        
                        
                    </Row>
                </Container>
                
            </ServicesWapper>
            <Stats />
            <CeoMessage />
        </Box>
    )
}
const ServicesWapper = styled.section`
    background: url(${ServicesBg});
    background-size: cover;
    background-position: center;
    background-repeat: repeat;
    padding-top: 0;
    padding-bottom: 0;
    .servicesRow{
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    }
    .secSerrvices{
        overflow: hidden;
    }
    
    .servicesPointsContent{
        display: flex;
        gap: 24px;
    }
    .servicesPointsContent:last-child{
        margin-bottom: 0 !important;
    }
    .servicesPointsContentInner{
        display: flex;
        flex-direction: column;
    }
    .servicesPointsContent:first-child{
        margin-bottom: 20px;
    }
    .services-col-ctnt{
        padding-top: 20px;
    }
    .services-col-img{
        display: flex;
        justify-content: end;
        position: relative;
        
        /* background: url(${VisionBg});
        background-repeat: no-repeat;
        background-position: left 0 bottom 0;
        background-size: 750px auto; */
    }
    .services-col-img img{
        z-index: 5;
    }

    
    body.rtl &{
        
        .main-heading-leader{
            font-size: 60px;
        }
        
        /* .main-heading-serv{
            font-size: 40px;
        } */
        
    }
    @media (max-width: 1199px) {
        
        body.rtl &{
            
            
        }
        
    }
    @media (max-width: 991px) {
        padding-bottom: 50px;
        padding-top: 40px;
        .com-col-img{
            display: flex;
            justify-content: center;
        }
        .main-heading-about{
            text-align: center;
        }
        
        .about-com-col{
            margin-top: 30px;
        }
        
        .servicesRow{
            flex-wrap: wrap;
        }
        .services-col-img{
            order: 1;
        }
        .services-col-ctnt{
            order: 2;
            margin-top: 30px;
        }
        
        
        
        .main-heading-serv{
            font-size: 30px;
        }
        /* .services-txt{
            text-align: center;
        } */
        .services-col-img{
            display: none;
        }
        body.rtl &{
            padding-bottom: 50px;
            padding-top: 0px;
            
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 575px) {
        /* .main-heading-leader{
            font-size: 35px;
        } */
    }
`
export default Services
